// File: src/pages/InvoiceDetail.jsx

import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { useVmCostByMonth } from "../../hooks/useVmCostsByMonth";
import { useGroupedCost } from "../../hooks/useGroupedCost";
import InvoiceHeader from "../../components/InvoiceDetailComponent/InvoiceHeader";
import VmCostsChart from "../../components/InvoiceDetailComponent/VmCostsChart";
import CostsCharts from "../../components/InvoiceDetailComponent/CostsCharts";

const InvoiceDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    getVmCostsByMonthAndYear,
    vmCosts,
    loading: vmLoading,
    error: vmError,
  } = useVmCostByMonth();
  const {
    getTotalCostsByService,
    getTotalCostsByMeter,
    costsByService,
    costsByMeter,
    loading: costLoading,
    error: costError,
  } = useGroupedCost();

  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  const invoiceData = location.state || {};
  const { month, year, amount, status, monthYear } = invoiceData;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (month && year) {
        await Promise.all([
          getVmCostsByMonthAndYear(year, month),
          getTotalCostsByService(year, month),
          getTotalCostsByMeter(year, month),
        ]);
      }
      setLoading(false);
    };
    fetchData();
  }, [month, year]);

  useEffect(() => {
    if (vmCosts && vmCosts.length > 0) {
      const transformed = vmCosts.map((vm) => ({
        name:
          vm.vmName.length > 15
            ? vm.vmName.substring(0, 12) + "..."
            : vm.vmName,
        cost: vm.totalCost,
        fullName: vm.vmName,
        status: vm.status,
        billingType: vm.billingType,
      }));
      setChartData(transformed);
    }
  }, [vmCosts]);

  const isLoading = loading || vmLoading || costLoading;

  if (isLoading) {
    return (
      <div className="bg-bg-main min-h-screen p-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center py-12">
            <div className="inline-block w-12 h-12 border-4 border-primary-cyan border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-400 mt-4">Loading invoice details...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-bg-main min-h-screen">
      {/* Sticky Header with back button */}
      <div className="sticky top-0 z-10 bg-primary-dark backdrop-blur-sm border-b border-gray-800">
        <div className="px-6 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white hover:text-white/80 transition group"
          >
            <MdArrowBack className="w-6 h-6 group-hover:-translate-x-1 transition" />
            <span className="text-xl">All Invoices</span>
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <InvoiceHeader
          id={id}
          month={month}
          year={year}
          amount={amount}
          status={status}
          monthYear={monthYear}
        />

        <VmCostsChart
          chartData={chartData}
          error={vmError}
        />

        <CostsCharts
          costsByService={costsByService}
          costsByMeter={costsByMeter}
          error={costError}
        />
      </div>
    </div>
  );
};

export default InvoiceDetail;